import { create } from "zustand";
import { User } from "../../Types/modeltypes";
import { loginProcess, sendOtp } from "../../apiEndpoints/navutils";

type LoginState = {
    isRemembered: boolean;
    eyeState: boolean;
    hideActivityIndicator: boolean,
    email: string;
    password: string;

    setEmail: (value: string) => void;
    setPassword: (value: string) => void;

    toggleRemember: () => void;
    toggleEyeState: () => void;
    onLoginWithCallback: (callback: (user: User) => void) => void;
    toggleActivityIndicator: () => void;
    sendOtp: (taskCompleted: () => void) => void
};

export const useLoginStore = create<LoginState>((set, get) => ({
    hideActivityIndicator: false,
    isRemembered: false,
    eyeState: false,

    email: "",
    password: "",

    setEmail: (value) => set({ email: value }),
    setPassword: (value) => set({ password: value }),

    toggleRemember: () =>
        set((state) => ({
            isRemembered: !state.isRemembered,
        })),

    toggleEyeState: () =>
        set((state) => ({
            eyeState: !state.eyeState,
        })),

    onLoginWithCallback: async (callback) => {
        const { email, password } = get();
        const user = await loginProcess(email, password);
        if (user) {
            callback(user)
        } else {
            set({ hideActivityIndicator: false })
        }
    },
    toggleActivityIndicator: () => {
        set((state) => ({
            hideActivityIndicator: !state.hideActivityIndicator,
        }))
    },
    sendOtp: async (taskCompleted) => {
        const { email } = get();
        set({ hideActivityIndicator: true })
        const result = await sendOtp(email, "old");
        set({ hideActivityIndicator: true })
        if (result) {
            taskCompleted()
        }
    }
}));
